import React from 'react';
import ReactDom from 'react-dom/client';
import Modal from 'react-modal';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import ConfigCustomProvider from './context/configCustom';

Modal.setAppElement('#root');
const root = ReactDom.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigCustomProvider>
        <App />
      </ConfigCustomProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
